import * as constants from './constants'

export const setWaitlistId = data => ({
    type: constants.SET_WAITLIST_ID,
    data,
})

export const getWaitingListState = () => ({
    type: constants.GET_WAITING_LIST_STATE,
})

export const setWaitingListState = data => ({
    type: constants.SET_WAITING_LIST_STATE,
    data,
})

export const failedWaitingListState = data => ({
    type: constants.GET_WAITING_LIST_STATE_ERROR,
    data,
})

export const subscribeWaitingList = () => ({
    type: constants.SUBSCRIBE_WAITING_LIST,
})

export const setResultSubscribeWaitingList = data => ({
    type: constants.SUCCESS_SUBSCRIBE_WAITING_LIST,
    data,
})

export const clearErrorState = () => ({
    type: constants.CLEAR_WAITLIST_ERROR_STATE,
})

export const clearWaitlistState = () => ({
    type: constants.CLEAR_WAITLIST_STATE,
})
